namespace Matrix {
    export interface ExcelImportResponse extends Serenity.ServiceResponse {
        Inserted?: number;
        Updated?: number;
        Deleted?: number;
        ErrorList?: string[];
    }
}
